import { ApiV1 } from "./Api.js";
import { GetCookie } from "@/utils/CookieUtil";

export const listarUsuarios = () => {
  return ApiV1().get("/usuario");
};

export const listarPalestrasInscritasUsuario = (dia) => {
  return ApiV1().get(`/usuario/palestras-inscritas`, { params: { dia } });
};

export const inscreverEmPalestra = (idPalestra) => {
  return ApiV1().post("/usuario/inscrever", { idPalestra });
};

export const cancelarInscricaoUsuario = (idInscricao) => {
  return ApiV1().delete(`/usuario/inscricao/${idInscricao}`);
};

export const registroAoVivo = ({ time, idPalestra }) => {
  return ApiV1().post("/usuario/streaming", { time, idPalestra });
};

export const gerarCertificado = () => {
  return ApiV1().get(`/usuario/gerar-certificado?token=${GetCookie("token")}`);
};

export const exportarUsuarios = () => {
  return ApiV1().get(`/exportar/usuarios`);
};

export const gerarCsvUsuarios = () => {
  return ApiV1().get(`/usuario/gerar-csv`);
};
